import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import {
  H,
  Flex,
  Text,
  AlertsContext,
  Alerts,
  FormErrorTypes,
  Alert,
  Button,
  DropdownOptions,
  TooltipPopup,
} from 'dash-ui';

import ForgotPasswordForm from 'pages/Authentication/ForgotPasswordPage/components/ForgotPasswordForm/ForgotPasswordForm';
import AuthenticationPageLayout from 'flow-components/AuthenticationPageLayout/AuthenticationPageLayout';
import { RoutesPath } from 'flow-components/routes/routes';

function ForgotPasswordPage() {
  const { t } = useTranslation('pages', { keyPrefix: 'forgotPasswordPage' });
  const { t: tForms } = useTranslation('forms');
  const theme = useTheme();
  const navigate = useNavigate();

  const { t: tAlerts } = useTranslation('common', { keyPrefix: 'alerts' });
  const { toggleAlert, state } = useContext(AlertsContext);

  const onClickLogin = (event: {
    preventDefault: () => void;
    stopPropagation: () => void;
  }) => {
    event.preventDefault();
    event.stopPropagation();

    navigate(RoutesPath.SignIn);
  };

  useEffect(
    () => () => {
      if (state[Alerts.ResetPasswordEmailsSent]) {
        toggleAlert(Alerts.ResetPasswordEmailsSent, false);
      }
    },
    [state, toggleAlert]
  );

  return (
    <AuthenticationPageLayout>
      <DropdownOptions />
      <TooltipPopup />
      <Flex flexDirection="column" w={334}>
        {state[Alerts.ResetPasswordEmailsSent] && (
          <Alert type={FormErrorTypes.Valid} mb={20}>
            {tAlerts`resetPasswordEmailsSent`}
          </Alert>
        )}

        <Flex flexDirection="column" w={334}>
          <Flex flexDirection="column">
            <H bold sm as={1}>{t`welcomeHeader`}</H>
            <Text color={theme.colors.n70}>{t`welcomeSubHeader`}</Text>
          </Flex>
          <ForgotPasswordForm />
        </Flex>

        <Button w="100%" type="button" variation="flat" onClick={onClickLogin}>
          {tForms`labels.signIn`}
        </Button>
      </Flex>
    </AuthenticationPageLayout>
  );
}

export default ForgotPasswordPage;
